/**
 * Options for the Help & Support forms. Submission now goes to the backend intake endpoint
 * (`/portal/support`) via `utils/supportService`; the signed-in user's identity is attached
 * server-side from their auth token, so the forms only collect the content below.
 */
export const SUPPORT_CATEGORIES = [
  "Question / how-to",
  "Something isn't working (bug)",
  "Account or access",
  "Data or privacy",
  "Feature request",
  "Other",
];

export const FEEDBACK_TYPES = [
  "Idea / suggestion",
  "Something's confusing",
  "Praise",
  "Other",
];
